/* V3 comparison cards: expand the same verified spec rows on every card. */
(() => {
  const initialize = (root) => {
    // Mobile is a genuine swipe carousel; arrow controls also support
    // non-touch devices and shoppers with limited swipe precision.
    root.querySelectorAll('[data-compare-mobile-nav]').forEach((nav) => {
      if (nav.dataset.compareSwipeInitialized === 'true') return;
      const section = nav.closest('.ls-product-compare');
      const track = section && section.querySelector('.ls-product-compare__cards');
      const cards = track && Array.from(track.querySelectorAll('.ls-product-compare__card'));
      const back = nav.querySelector('[data-compare-prev]');
      const forward = nav.querySelector('[data-compare-next]');
      const counter = nav.querySelector('[data-compare-index]');
      if (!track || !cards || cards.length < 2 || !back || !forward || !counter) return;
      nav.dataset.compareSwipeInitialized = 'true';

      let current = 0;
      let pending = false;
      const targetX = (index) => cards[index].offsetLeft - cards[0].offsetLeft;
      const update = () => {
        pending = false;
        const left = track.scrollLeft;
        current = cards.reduce((best, _, index) =>
          Math.abs(targetX(index) - left) < Math.abs(targetX(best) - left) ? index : best, 0);
        counter.textContent = String(current + 1);
        back.disabled = current === 0;
        forward.disabled = current === cards.length - 1;
      };
      track.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      const move = (step) => {
        update();
        const next = Math.max(0, Math.min(cards.length - 1, current + step));
        track.scrollTo({
          left: targetX(next),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      back.addEventListener('click', () => move(-1));
      forward.addEventListener('click', () => move(1));
      update();
    });
    const buttons = root.querySelectorAll('[data-compare-toggle]');
    buttons.forEach((button) => {
      if (button.dataset.compareInitialized === 'true') return;
      const section = button.closest('.ls-product-compare');
      const target = section && section.querySelector('#' + CSS.escape(button.getAttribute('aria-controls') || ''));
      const extras = target && target.querySelectorAll('[data-compare-extra]');
      if (!extras || !extras.length) return;
      button.dataset.compareInitialized = 'true';
      extras.forEach((item) => { item.hidden = true; });
      button.hidden = false;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        extras.forEach((item) => { item.hidden = !expanded; });
        const label = button.querySelector('[data-compare-toggle-label]');
        if (label) label.textContent = expanded
          ? button.dataset.expandedLabel || 'Show fewer differences'
          : button.dataset.collapsedLabel || 'Show more differences';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();